import { render, staticRenderFns } from "./CardLink.vue?vue&type=template&id=d219ae4e&scoped=true&"
import script from "./CardLink.vue?vue&type=script&lang=ts&"
export * from "./CardLink.vue?vue&type=script&lang=ts&"
import style0 from "./CardLink.vue?vue&type=style&index=0&id=d219ae4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d219ae4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon})
